import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  initialState,
  NewBranchOfficeData
} from '@/modules/allies/allies/store/branchOfficeSlice/initialState.ts'

const branchOfficeSlice = createSlice({
  name: 'branchOffice',
  initialState,
  reducers: {
    setIsCreateBranchOfficeModalOpen: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isCreateBranchOfficeModalOpen = action.payload
    },
    setIsEditBranchOfficeModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isEditBranchOfficeModalOpen = action.payload
    },
    setSelectedBranchOfficeId: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.selectedBranchOfficeId = action.payload
    },
    setBranchOfficeFilters: (state, action: PayloadAction<string>) => {
      state.branchOfficeFilters = action.payload
    },
    setNewBranchOfficeData: (
      state,
      action: PayloadAction<NewBranchOfficeData>
    ) => {
      state.newBranchOfficeData = action.payload
    },
    reset: () => initialState
  }
})

export const branchOfficeActions = branchOfficeSlice.actions
export const { reducer: branchOfficesReducer } = branchOfficeSlice
